import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "60vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", gap: "16px",
          padding: "40px 20px", textAlign: "center",
        }}>
          <div style={{ fontSize: "48px" }}>😵</div>
          <div style={{ fontSize: "18px", fontWeight: "700", color: "var(--text-primary)" }}>
            Oops! Có lỗi xảy ra
          </div>
          <div style={{ fontSize: "14px", color: "var(--text-muted)", maxWidth: "300px" }}>
            Đã có sự cố không mong muốn. Hãy thử tải lại trang.
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "linear-gradient(135deg, #10B981, #059669)",
              border: "none", borderRadius: "12px",
              padding: "12px 24px", color: "#fff",
              fontSize: "14px", fontWeight: "600", cursor: "pointer",
              boxShadow: "0 4px 14px rgba(16,185,129,0.3)",
            }}>
            🔄 Tải lại trang
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
